import type {
  HotelAmenityItem,
  HotelAmenityCategories,
} from '@shared/types/hotel-content';

const SHOW_MAX_MAIN_AMENITIES_NUM = 6;
const MWEB_MAX_TOP_AMENITIES_NUM = 20;

type UniqueAmenity = {
  [key: string]: HotelAmenityItem;
};

export const unique = (arr: HotelAmenityItem[]) => {
  const uniqueObj: UniqueAmenity = {};
  arr.forEach((item) => {
    uniqueObj[JSON.stringify(item)] = item;
  });
  return Object.keys(uniqueObj).map((u) => JSON.parse(u));
};

export const filterAndProcessAmenities = (
  amenityCategories: HotelAmenityCategories,
) => {
  const groups = amenityCategories.filter(
    (amenityCategory) =>
      amenityCategory.type !== 'HOTEL_AMENITY_CATEGORY_TYPE_POPULAR',
  );

  const main = amenityCategories.find(
    (amenityCategory) =>
      amenityCategory.type === 'HOTEL_AMENITY_CATEGORY_TYPE_POPULAR',
  );

  const allAmenityItems = groups.flatMap((group) =>
    group.items.map((item) => item),
  );

  const mainAmenities = unique([
    ...(main?.items ?? []),
    ...allAmenityItems,
  ]).slice(0, MWEB_MAX_TOP_AMENITIES_NUM);

  const topMainAmenities = mainAmenities.slice(0, SHOW_MAX_MAIN_AMENITIES_NUM);

  return { groups, mainAmenities, topMainAmenities };
};
